import { useEffect } from "react"

import useSchema from "../schema/useSchema"

const usePermutive = (article) => {
  const schema = useSchema(article)

  useEffect(() => {
    // set up permutive tracking
    const categories = [article.category || "wellness", article.subcategory || "content"]
    window.pDataLayer = window.pDataLayer || {}
    window.pDataLayer.article = {
      tags: article.tags,
      title: article.titles.site || article.titles.body,
      categories,
      wordCount: schema.articleBody.split(/\s+/).length,
      containsProduct: schema.products?.length > 0,
      publishedDate: schema.datePublished,
      branded: !!article.partner,
    }
  }, [article, schema])
}

export default usePermutive
